var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"has-text-centered"},[_c('boolean-rep',{staticClass:"bool-icon",attrs:{"value":_vm.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }